<template>
  <IntercomTopbar
    :app-name="appName"
    :product-name="productName"
    :business-name="businessName"
    :user="user"
    :global-user="globalUser"
    :search-placeholder="searchPlaceholder"
    :search-fn="searchFn"
    @select-result="handleSelectResult"
    @notifications="$emit('notifications')"
    @settings="$emit('settings')"
    @logout="$emit('logout')"
  />
</template>

<script setup>
import { IntercomTopbar } from '@shared/components/intercom'

const props = defineProps({
  appName: { type: String, default: 'OnePlaceHQ' },
  productName: { type: String, default: 'Seva' },
  businessName: { type: String, default: '' },
  user: { type: Object, default: () => ({}) },
  globalUser: { type: Object, default: () => ({}) },
  searchPlaceholder: { type: String, default: 'Search patrons, donations...' },
  searchFn: { type: Function, default: null },
})

const emit = defineEmits(['select-patron', 'select-donation', 'notifications', 'settings', 'logout'])

const handleSelectResult = (result) => {
  if (result.type === 'patron') {
    emit('select-patron', result)
  } else if (result.type === 'donation') {
    emit('select-donation', result)
  }
}
</script>
